import './assets/css/root.css'
import './axios.config.js'
import Routes from './routes/Index'
import ErrorBoundary from './ErrorBoundary';
import { Toaster } from 'react-hot-toast';
import AuthenticateHandler from './AuthenticateHandler'
import { StoreProvider } from './components/providers/StoreContext';
import { StatusBar } from '@capacitor/status-bar';
import { getPlatformName } from './utils/device.util.js';
import useLiveUpdate from './hooks/useLiveUpdate.js'
import NativePullToRefresh from './NativePullToRefresh.jsx';
import Maintenance from './Maintenance.jsx';
import { useEffect } from 'react';

function App() {
  useLiveUpdate();

  useEffect(() => {
    const setupStatusBar = async () => {
      if (await getPlatformName() === "ios") {
        await StatusBar.setOverlaysWebView({ overlay: false });
      }
    };

    setupStatusBar();
  }, []);

  return (
    <ErrorBoundary>
      <StoreProvider>
        <NativePullToRefresh>
          <Maintenance>
            <AuthenticateHandler>
              <Routes />
            </AuthenticateHandler>
          </Maintenance>
        </NativePullToRefresh>
        <Toaster position="top-right" />
      </StoreProvider>
    </ErrorBoundary>
  )
}

export default App
